// extracted by mini-css-extract-plugin
module.exports = {"text-wrapper":"CustomerProfileText_text-wrapper__9v1nK","heading":"CustomerProfileText_heading__J8qh7","subheading":"CustomerProfileText_subheading__0BALy"};